import { createEnv } from "@t3-oss/env-nextjs";
import { vercel } from "@t3-oss/env-nextjs/presets-zod";
import { z } from "zod";

const environment_ = createEnv({
  client: {
    NEXT_PUBLIC_API_URL: z.string().trim().toLowerCase().default("/api"),
    NEXT_PUBLIC_ENVIRONMENT: z.string().trim().toLowerCase().optional(),
    NEXT_PUBLIC_IS_DOCKER_BUILD: z
      .string()
      .trim()
      .default("false")
      .transform((value) => value === "true"),
    NEXT_PUBLIC_PUBLIC_FILE_PATH: z.string().default(""),
    NEXT_PUBLIC_SENTRY_DSN: z.string().trim().default(""),
  },
  emptyStringAsUndefined: true,
  extends: [vercel()],
  runtimeEnv: {
    GB_DBNAME: process.env.GB_DBNAME,
    GM_DBURL: process.env.GM_DBURL,
    GM_DBUSER: process.env.GM_DBUSER,
    NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
    NEXT_PUBLIC_IS_DOCKER_BUILD: process.env.NEXT_PUBLIC_IS_DOCKER_BUILD,
    NEXT_PUBLIC_PUBLIC_FILE_PATH: process.env.NEXT_PUBLIC_PUBLIC_FILE_PATH,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    NODE_ENV: process.env.NODE_ENV,
    PGDATABASE: process.env.PGDATABASE,
    PGHOST: process.env.PGHOST,
    PGPASSWORD: process.env.PGPASSWORD,
    PGPORT: process.env.PGPORT,
    PGSSLMODE: process.env.PGSSLMODE,
    PGUSER: process.env.PGUSER,
    rdsOwnerUsername: process.env.rdsOwnerUsername,
    rdsRootPassword: process.env.rdsRootPassword,
    ROOT_PGDATABASE: process.env.ROOT_PGDATABASE,
    ROOT_PGPASSWORD: process.env.ROOT_PGPASSWORD,
    ROOT_PGUSER: process.env.ROOT_PGUSER,
    VERCEL_ENV: process.env.VERCEL_ENV,
  },
  server: {
    GB_DBNAME: z.string().trim().min(1).optional(),
    GM_DBURL: z
      .string()
      .trim()
      .min(1)
      .transform((value) => encodeURIComponent(value))
      .optional(),
    GM_DBUSER: z.string().trim().min(1).optional(),
    NODE_ENV: z.enum(["development", "production"]).default("development"),
    PGDATABASE: z.string().trim().min(1),
    PGHOST: z
      .string()
      .trim()
      .min(1)
      .transform((value) => encodeURIComponent(value)),
    PGPASSWORD: z.string().trim().min(1),
    PGPORT: z.coerce.number().default(5432),
    PGSSLMODE: z.string().optional(),
    PGUSER: z.string().trim().min(1),
    rdsOwnerUsername: z.string().trim().min(1).optional(),
    rdsRootPassword: z.string().trim().min(1).optional(),
    ROOT_PGDATABASE: z.string().trim().min(1).optional(),
    ROOT_PGPASSWORD: z.string().trim().min(1).optional(),
    ROOT_PGUSER: z.string().trim().min(1).optional(),
    VERCEL_ENV: z.enum(["preview", "production"]).default("preview"),
  },
});

const appConfigFileName = process.env.NODE_ENV === "development" ? "example.config.json" : "config.json";
const appConfigFilePath = `${environment_.NEXT_PUBLIC_PUBLIC_FILE_PATH}/${appConfigFileName}`;

export const environment = {
  appConfigFileName,
  appConfigFilePath,
  ...environment_,
};
